import React from 'react';

const ControlValve3Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	
		<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="0.0063" y1="112.5059" x2="1.0063" y2="112.5059" gradientTransform="matrix(0 -28.1533 -28.1533 0 3223.6685 98.5904)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect y="70.27" fill={`url(#${uid}_2)`} width="112.5" height="28.154" />
</g>
<g id={`${uid}_3`}>
	
		<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="0" y1="112.5" x2="1" y2="112.5" gradientTransform="matrix(37.5 0 0 -37.5 37.5 4228.0938)">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<rect x="37.5" fill={`url(#${uid}_4)`} width="37.5" height="18.694" />
	<rect x="46.847" y="18.139" fill="none" width="18.694" height="38.609" />
	
		<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="0.0156" y1="112.5156" x2="1.0156" y2="112.5156" gradientTransform="matrix(18.6943 0 0 -18.6943 46.5516 2140.8545)">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<rect x="46.847" y="18.139" fill={`url(#${uid}_5)`} width="18.694" height="38.609" />
	<rect x="37.5" y="56.194" fill="none" width="37.499" height="56.306" />
	
		<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="-0.0049" y1="112.4951" x2="0.9951" y2="112.4951" gradientTransform="matrix(0 -56.3057 -56.3057 0 6390.3794 112.2546)">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<rect x="37.5" y="56.194" fill={`url(#${uid}_6)`} width="37.499" height="56.306" />
	<polygon fill={`${startColor}`} points="39.752,41.933 46.846,46.847 65.541,46.847 72.635,41.933  " />
</g>
<g id={`${uid}_7`}>
	<rect x="21.059" y="58.559" fill="none" width="9.347" height="51.576" />
	
		<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="-0.0039" y1="112.4961" x2="0.9961" y2="112.4961" gradientTransform="matrix(0 -51.5762 -51.5762 0 5827.8242 109.918)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect x="21.059" y="58.559" fill={`url(#${uid}_8)`} width="9.347" height="51.576" />
	
		<linearGradient id={`${uid}_9`} gradientUnits="userSpaceOnUse" x1="-0.0034" y1="112.4961" x2="0.9966" y2="112.4961" gradientTransform="matrix(0 -46.8467 -46.8467 0 5279.394 107.6127)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect x="4.617" y="60.924" fill={`url(#${uid}_9)`} width="9.347" height="46.848" />
</g>
<g id={`${uid}_10`}>
	
		<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="-0.0039" y1="112.498" x2="0.9961" y2="112.498" gradientTransform="matrix(0 -51.5762 -51.5762 0 5888.8867 109.918)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect x="81.982" y="58.559" fill={`url(#${uid}_11)`} width="9.346" height="51.576" />
	
		<linearGradient id={`${uid}_12`} gradientUnits="userSpaceOnUse" x1="-0.0034" y1="112.4971" x2="0.9966" y2="112.4971" gradientTransform="matrix(0 -46.8467 -46.8467 0 5373.2065 107.6127)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect x="98.424" y="60.924" fill={`url(#${uid}_12)`} width="9.348" height="46.848" />
</g>
<g id={`${uid}_13`}>
	
		<linearGradient id={`${uid}_14`} gradientUnits="userSpaceOnUse" x1="0.0068" y1="112.5078" x2="1.0068" y2="112.5078" gradientTransform="matrix(32.8823 0 0 -32.8823 39.5234 3736.9141)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<rect x="39.753" y="32.77" fill={`url(#${uid}_14)`} width="32.882" height="9.347" />
</g>
    </svg>
  );
};

export default ControlValve3Icon;
